/**
 * PRP-MCP-4 work item 13: the fixed price list / tax jurisdiction line, shown
 * next to every ESX export control. Always visible (not dismissible), so it
 * survives "Don't show this again" on the export dialogs.
 */
import { XACTIMATE_PRICE_LIST_NOTICE } from '../lib/notices';

export default function ExportPriceListNote({ className = '' }: { className?: string }) {
  return (
    <p
      className={`text-[11px] ${className}`}
      style={{ color: 'var(--text-muted, #64748b)' }}
      data-testid="export-price-list-note"
    >
      {XACTIMATE_PRICE_LIST_NOTICE}
    </p>
  );
}
